import React from "react";
import "../index.css";
// import brightonio from "../media/brightonio.png";
// import hand from "../media/mano.png";
import ielts from "../media/ielts.jpg";
import aptis from "../media/aptis.jpg";
import toefl from "../media/toefl.jpg";
import oopt from "../media/oopt.jpg";
import seccion from "../media/img-01.png";
import CardCursos from "../components/Cards/CardCursos";
import profesoresData from "../data/profesores.json";
import ProfesorCard from "components/ProfesorCard";
import Seo from "components/Seo/Seo";
import CardEstadisticas from "components/Index/CardEstadisticas";
import TestimonialsMarquee from "components/Testimonios/TestimonialsMarquee";
import cursosData from "../data/cursos.json";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import CarruselDos from "components/Carrusel/CarruselDos";
import Hero from "components/hero/Hero";
import CardInfo from "components/Cards/CardInfo";
import CardCursosPage from "components/Cards/CardCursosPage";

const dataEstadisticas = [
  {
    icon: "fa-solid fa-user-graduate",
    numero: "+ 1000",
    texto: "Estudiantes certificados en OOPT",
    bgColor: "bg-blue-100",
    textColor: "text-blue-800",
  },
  {
    icon: "fa-solid fa-award",
    numero: "+ 500",
    texto: "Estudiantes certificados en IELTS",
    bgColor: "bg-rose-400",
    textColor: "text-rose-800",
  },
  {
    icon: "fa-solid fa-trophy",
    numero: "+ 2700",
    texto: "Estudiantes Certificados en APTIS",
    bgColor: "bg-lime-400",
    textColor: "text-lime-600",
  },
  {
    icon: "fa-solid fa-chalkboard-user",
    numero: "+ 25",
    texto: "Profesores Certificados",
    bgColor: "bg-yellow-400",
    textColor: "text-yellow-700",
  },
];
const Exams = [
  { name: "IELTS", img: ielts, link: "/certificaciones/ielts" },
  { name: "TOEFL", img: toefl, link: "/certificaciones/toefl" },
  { name: "APTIS", img: aptis, link: "/certificaciones/aptis" },
  { name: "OOPT", img: oopt, link: "/certificaciones/oopt" },
];
const itemsCarrusel = cursosData.map((curso, index) => (
  <CardCursosPage
    key={index}
    curso={curso}
  />
));
const itemsProfes = profesoresData.map((profes, index) => (
  <ProfesorCard key={index} profesor={profes} />
));
const ExamnCard = ({ link, img, exam }) => {
  return (
    <div className="w-full h-full md:w-0 md:h-full md:flex-grow-[1] transition-all duration-300 ease-in-out md:hover:flex-grow-[4] overflow-hidden rounded-lg rounded-tl-none">
      <Link to={link}>
        <img
          src={img}
          width={1080}
          loading="lazy"
          alt={`Examen de certificacion ${exam}`}
          className="object-cover h-full w-full hover:scale-110 transition duration-300 ease-in-out"
        />
      </Link>
    </div>
  );
};
function Index() {
  return (
    <>
      <Seo />
      <Hero />
      <section className="min-h-screen flex flex-col gap-8 justify-center items-start px-4 sm:px-6 lg:px-8 xl:px-20 py-16 sm:py-20 lg:py-24 text-base sm:text-lg lg:text-xl">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-primario w-full text-center md:text-left">
          Por qué Brighton es Diferente
        </h2>

        <div className="flex flex-col lg:flex-row w-full justify-between items-center gap-4">
          <p className="w-full lg:w-1/2 text-center md:text-left">
            Descubre una experiencia educativa diseñada para inspirarte y
            conectar. No es solo inglés, es tu futuro.
          </p>

          <Link
            to="/nosotros"
            className="outline outline-2 outline-primario text-primario shadow-custom-first py-2 px-4 font-bold rounded-lg hover:bg-yellow-1 transition duration-200 w-max"
          >
            Acerca de Nosotros
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 w-full gap-6">
          <CardInfo
            title="Ambiente Inmersivo"
            description="Practica inglés en situaciones reales dentro y fuera del aula. Aprende viviendo el idioma."
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="icon icon-tabler icons-tabler-filled icon-tabler-messages"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M20.901 14.995l-.044 -.006a.4 .4 0 0 1 -.102 -.02l-.045 -.012l-.048 -.017l-.045 -.016l-.043 -.02l-.045 -.022l-.04 -.024l-.044 -.026l-.043 -.032l-.036 -.027a1 1 0 0 1 -.073 -.066l-2.707 -2.707h-6.586a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h9a2 2 0 0 1 2 2v10a1 1 0 0 1 -.076 .383l-.02 .043l-.022 .045l-.024 .04l-.026 .044l-.032 .043l-.027 .036a1 1 0 0 1 -.578 .347l-.052 .008l-.044 .006a1 1 0 0 1 -.198 0" />
              <path d="M7 8.999v1.001a4 4 0 0 0 4 4h4v3a2 2 0 0 1 -2 2h-6.586l-2.707 2.707c-.63 .63 -1.707 .184 -1.707 -.707v-10a2 2 0 0 1 2 -2z" />
            </svg>
          </CardInfo>
          <CardInfo
            title="Eventos Exclusivos"
            description="Talleres, clubes de conversación y actividades en contexto para enriquecer tu aprendizaje."
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-calendar-week"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12" />
              <path d="M16 3v4" />
              <path d="M8 3v4" />
              <path d="M4 11h16" />
              <path d="M7 14h.013" />
              <path d="M10.01 14h.005" />
              <path d="M13.01 14h.005" />
              <path d="M16.015 14h.005" />
              <path d="M13.015 17h.005" />
              <path d="M7.01 17h.005" />
              <path d="M10.01 17h.005" />
            </svg>
          </CardInfo>
          <CardInfo
            title="Certificaciones Oficiales"
            description="Preparamos a nuestros estudiantes para alcanzar estándares internacionales."
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="icon icon-tabler icons-tabler-filled icon-tabler-rosette-discount-check"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12.01 2.011a3.2 3.2 0 0 1 2.113 .797l.154 .145l.698 .698a1.2 1.2 0 0 0 .71 .341l.135 .008h1a3.2 3.2 0 0 1 3.195 3.018l.005 .182v1c0 .27 .092 .533 .258 .743l.09 .1l.697 .698a3.2 3.2 0 0 1 .147 4.382l-.145 .154l-.698 .698a1.2 1.2 0 0 0 -.341 .71l-.008 .135v1a3.2 3.2 0 0 1 -3.018 3.195l-.182 .005h-1a1.2 1.2 0 0 0 -.743 .258l-.1 .09l-.698 .697a3.2 3.2 0 0 1 -4.382 .147l-.154 -.145l-.698 -.698a1.2 1.2 0 0 0 -.71 -.341l-.135 -.008h-1a3.2 3.2 0 0 1 -3.195 -3.018l-.005 -.182v-1a1.2 1.2 0 0 0 -.258 -.743l-.09 -.1l-.697 -.698a3.2 3.2 0 0 1 -.147 -4.382l.145 -.154l.698 -.698a1.2 1.2 0 0 0 .341 -.71l.008 -.135v-1l.005 -.182a3.2 3.2 0 0 1 3.013 -3.013l.182 -.005h1a1.2 1.2 0 0 0 .743 -.258l.1 -.09l.698 -.697a3.2 3.2 0 0 1 2.269 -.944zm3.697 7.282a1 1 0 0 0 -1.414 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" />
            </svg>
          </CardInfo>
        </div>
      </section>
      <section className="flex flex-col gap-4 items-center py-16 sm:py-20">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-primario text-center">
          Programas De Formación
        </h2>
        <CarruselDos children={itemsCarrusel} />
      </section>
      <section className="bg-primario">
        <div className="text-center px-4 sm:px-6 lg:px-8 xl:px-20 py-16 sm:py-20 space-y-5">
          <h2 className="capitalize text-3xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-yellow-1">
            Prepárate para el éxito global
          </h2>

          <p className="text-white text-base sm:text-lg lg:text-xl 2xl:text-2xl mx-auto hyphens-none">
            Nuestros programas de entrenamiento están diseñados para brindarte
            las habilidades y el conocimiento para enfrentarte con confianza a
            los exámenes internacionales y nacionales. Con profesores
            certificados, materiales actualizados y un enfoque práctico, te
            preparamos para alcanzar tus metas académicas y profesionales.
          </p>
        </div>

        <div className="flex flex-col md:flex-row w-full gap-2 px-4 md:px-0 pb-4 h-[500px] sm:h-[650px] md:h-[550px]">
          {Exams.map((value, index) => (
            <ExamnCard key={index} {...value} exam={value.name} />
          ))}
        </div>
      </section>
      <section className="min-h-[80vh] bg-primario p-4 sm:px-6 lg:px-8 xl:px-20 py-16 sm:py-20 bg-call-to-action bg-no-repeat bg-center md:bg-left-bottom bg-cover md:bg-contain  flex flex-row text-center justify-end">
        <div className="w-full md:w-1/2 p-6 bg-transparent/20 backdrop-blur-lg rounded-30 flex flex-col gap-4 justify-center items-center md:items-end">
          <h2 className="capitalize text-3xl sm:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-yellow-1">
            No pierdas esta oportunidad
          </h2>
          <h3 className="text-xl xl:text-2xl text-white hyphens-none">
            Certifica tu inglés en Brighton y abre las puertas a un mundo de
            oportunidades académicas y profesionales.
          </h3>
          <a
            href="https://wa.link/54lqy2"
            target="_blank"
            rel="noreferrer"
            className="capitalize self-center text-2xl font-bold px-5 py-2 xl:px-6 xl:py-3 2xl:text-3xl bg-white outline outline-2 outline-yellow-1 text-primario w-max rounded-lg rounded-tl-none  hover:bg-yellow-100 duration-200 shadow-custom-yellow-1"
          >
            ¡Regístrate Hoy!
          </a>
        </div>
      </section>
      <section className="py-12 sm:py-16 lg:py-20 flex flex-col gap-4">
        <h2 className="capitalize text-2xl sm:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl font-bold text-center text-primario">
          Conoce a nuestros <strong className="text-secundario">docentes</strong>
        </h2>
        <CarruselDos children={itemsProfes} />
      </section>
      <section className="p-12 sm:p-16 lg:p-20 flex flex-col gap-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl hyphens-none text-center w-full font-bold text-blue-4">
              Brighton es la elección número uno para desarollar tu inglés
            </h2>
            <CardEstadisticas data={dataEstadisticas} />
        </section>
      <div className="w-full hyphens-auto scroll-smooth transition-colors duration-500 ease-in-out">
        {/* <section className="bg-secundario flex flex-col gap-10 rounded-b-30 relative z-10">
          <div className="my-12 mx-5 md:m-20 xl:m-40 space-y-12">
            <h2 className="text-5xl sm:text-6xl 2xl:text-7xl text-primario font-bold font-Bebas text-center xl:w-3/4 mx-auto">
              Descubre por qué Brighton es tu mejor opción para aprender
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 w-full mx-auto md:w-full xl:w-3/4">
              <div className="grid gap-5">
                <WhyCard
                  colorPrimario="#fffbeb"
                  titulo="Certificaciones Internacionales"
                  descripcion="En Brighton, ofrecemos preparación especializada para
                      certificaciones internacionales como el IELTS, TOEFL,
                      examenes Cambridg; para certificaciones nacionales como APTIS y OOPT. Estas certificaciones te abrirán puertas en
                      universidades, empresas y oportunidades globales. "
                  boton="Conoce más"
                  icono="fa-trophy"
                />
                <WhyCard
                  colorPrimario="#fffbeb"
                  titulo="Profesores Certificados Internacionalmente"
                  descripcion="Nuestros profesores están altamente capacitados y con experiencia en contextos globales. Su enfoque se centra en desarrollar tus habilidades y confianza en el idioma."
                  icono="fa-person-chalkboard"
                />
              </div>
              <div className="grid gap-5">
                <WhyCard
                  colorPrimario="#fffbeb"
                  titulo="Clases Online"
                  descripcion="Participa de nuestras clases en línea desde la comodidad de tu hogar o donde te encuentres y disfruta de una experiencia dinámica y eficaz."
                  icono="fa-wifi"
                />
                <WhyCard
                  colorPrimario="#fffbeb"
                  titulo="Metodología Basada en Contextos Reales"
                  descripcion="Nuestra metodología innovadora está diseñada para que aprendas inglés en contextos reales, te sumergimos en situaciones auténticas para que no solo aprendas, sino que te sientas preparado para comunicarte eficazmente en inglés en cualquier entorno."
                  icono="fa-earth-americas"
                />
              </div>
            </div>
          </div>
        </section> */}

        
        <section>
          <TestimonialsMarquee />
        </section>
      </div>
    </>
  );
}

export default Index;
